// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"467":"dfb74478","529":"6c66bafa"}[chunkId] + ".chunk.js";
};